import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.css";
import { Col, Input, Label, Row } from "reactstrap";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import DatePicker from "react-datepicker";
import { formatNumberWithCommas } from "helpers/format";

export interface Props {
  id?: any;
  formik: any;
  dataSection?: any;
  dataPlan?: any;
  dataPlanAll?: any;
  setSectionInformationChoose?: any;
  setPlanInformationChoose?: any;
}

registerLocale("en", en);
registerLocale("ko", ko);

const PurchaseInformation = ({
  id,
  formik,
  dataSection,
  dataPlan,
  setPlanInformationChoose,
  setSectionInformationChoose,
  dataPlanAll,
}: Props) => {
  const { t } = useTranslation(); 
  const [formatDataPlan, setFormatDataPlan] = useState<any>([]);

  useEffect(() => {
    setFormatDataPlan(dataPlan || [])
    if(formik?.values?.planId && dataPlan) {
      const haveInDataPlan = dataPlan?.find((pl: any) => pl?.value == formik?.values?.planId);
      if(haveInDataPlan) return;

      const planChoose = dataPlanAll?.find((pl: any) => pl?.value == formik?.values?.planId);
      if(planChoose) {
        setFormatDataPlan([...dataPlan, planChoose])
      }
    }
  }, [dataPlan, formik?.values?.planId]);

  return (
    <React.Fragment>
      <div
        className="d-flex flex-column mb-4 pt-3 pb-1 px-3 position-relative"
        style={{
          border: "1px dashed var(--vz-primary)",
          borderRadius: "4px",
        }}
      >
        <span
          className="text-primary position-absolute fs-13 px-1"
          style={{
            backgroundColor: "var(--vz-secondary-bg)",
            top: "0px",
            transform: "translateY(-50%)",
          }}
        >
          {t("Purchase Information")}
        </span>
        <div className="d-flex flex-column flex-lg-row gap-3 gap-lg-4">
          <Row>
            <Col md={12} lg={12}>
              <div className="mb-3">
                <Label className="form-label">
                  {t("Plan")} <span className="text-danger">*</span>
                </Label>

                <DropdownOptionNew
                  name="planId"
                  dataList={formatDataPlan || []}
                  placeholder={`${t("Plan")}...`}
                  className="dropdown-status-rounded"
                  classNamePrefix="name-prefix"
                  initialValue={formik?.values?.planId}
                  onChangeSelect={(event: any) => {
                    const dataPlanDefault = event?.data;
                    if(dataPlanDefault?.isActive === false) return;

                    let formatFeatureJobPost = dataPlanDefault?.features?.find(
                      (item: any) => item?.key === "POST_JOB"
                    );
                    const formatPlanInfo = {
                      durationDays: formatFeatureJobPost?.durationDays,
                      maxUsage: formatFeatureJobPost?.maxUsage,
                      priceType: dataPlanDefault?.priceType,
                      planId: dataPlanDefault?.id,
                      priceFinal: dataPlanDefault?.price?.priceFinal,
                      vatRate: dataPlanDefault?.price?.vatRate,
                    };
                    setPlanInformationChoose(formatPlanInfo);
                    formik.setFieldValue("planId", event?.value);
                  }}
                  isHasOptionAll={false}
                  showPricePlan={true}
                  // disabled={(!hasPlanPurchases && id) ? false : (id ? true : false)}
                />

                {formik.touched.planId && formik.errors.planId ? (
                  <div className="text-danger mt-2">{formik.errors.planId}</div>
                ) : null}
              </div>
            </Col>

            <Col md={12} lg={12}>
              <div className="mb-3">
                <Label className="form-label">{t("Section")}</Label>

                <DropdownOptionNew
                  name="sectionId"
                  dataList={dataSection || []}
                  placeholder={`${t("Section")}...`}
                  className="dropdown-status-rounded"
                  classNamePrefix="name-prefix"
                  initialValue={formik?.values?.sectionId}
                  onChangeSelect={(e: any) => {
                    formik.setFieldValue("sectionId", e?.value);
                    if (e?.data) {
                      setSectionInformationChoose({
                        priceFinal: e?.data?.priceFinal,
                        sectionId: e?.data?.id,
                      });
                    }else {
                      setSectionInformationChoose(null)
                    }

                    if(id && e?.value) {
                      const planChoose = dataPlan?.find((pl: any) => pl?.value == formik?.values?.planId)?.data;
                      let formatFeatureJobPost = planChoose?.features?.find(
                        (item: any) => item?.key === "POST_JOB"
                      );
                      const formatPlanInfo = {
                        durationDays: formatFeatureJobPost?.durationDays,
                        maxUsage: formatFeatureJobPost?.maxUsage,
                        priceType: planChoose?.priceType,
                        planId: planChoose?.id,
                        priceFinal: planChoose?.price?.priceFinal,
                        vatRate: planChoose?.price?.vatRate,
                      };
                      setPlanInformationChoose(formatPlanInfo)
                    }
                  }}
                  isHasOptionAll={false}
                  disabled={!formik?.values?.planId}
                  showPriceSection={true}
                  isClearable={true}
                />

                {formik.touched.sectionId && formik.errors.sectionId ? (
                  <div className="text-danger mt-2">{formik.errors.sectionId}</div>
                ) : null}
              </div>
            </Col>

            <Col md={12} lg={12} className="datepicker-time">
              <div className="mb-3">
                <Label htmlFor="purchaseStartDate" className="form-label">
                  {t("Plan Start Date")} <span className="text-danger">*</span>
                </Label>

                <div className="w-100">
                  <DatePicker
                    name={"purchaseStartDate"}
                    className="form-control"
                    selected={formik?.values?.purchaseStartDate}
                    placeholderText={t("Plan Start Date")}
                    onChange={(date: any) => {
                      formik.setFieldValue("purchaseStartDate", date);
                    }}
                    dateFormat="yyyy-MM-dd"
                    isClearable={false}
                    // disabled={planInformationChoose?.priceType === "FREE" || isFreePlanPurchase}
                  />
                </div>
                {formik.touched.purchaseStartDate &&
                formik.errors.purchaseStartDate ? (
                  <div className="text-danger mt-2">
                    {String(formik.errors.purchaseStartDate)}
                  </div>
                ) : null}
              </div>
            </Col>

            <Col md={12} lg={12} className="datepicker-time">
              <div className="mb-3">
                <Label htmlFor="purchaseEndDate" className="form-label">
                  {t("Plan End Date")} <span className="text-danger">*</span>
                </Label>

                <div className="w-100">
                  <DatePicker
                    name={"purchaseEndDate"}
                    className="form-control"
                    selected={formik?.values?.purchaseEndDate}
                    placeholderText={t("Plan End Date")}
                    onChange={(date: any) => {
                      formik.setFieldValue("purchaseEndDate", date);
                    }}
                    dateFormat="yyyy-MM-dd"
                    // disabled={(!id && isDisablePurchaseEndDate)}
                  />
                </div>

                {formik.touched.purchaseEndDate &&
                formik.errors.purchaseEndDate ? (
                  <div className="text-danger mt-2">
                    {String(formik.errors.purchaseEndDate)}
                  </div>
                ) : null}
              </div>
            </Col>

            <Col md={12} lg={12}>
              <div className="mb-3">
                <Label htmlFor="vatAmount" className="form-label">
                  {t("VAT Amount")}{" "}
                </Label>
                <Input
                  name="vatAmount"
                  type="text"
                  className="form-control"
                  id="vatAmount"
                  placeholder={t("VAT Amount")}
                  value={formatNumberWithCommas(formik?.values?.vatAmount)}
                  disabled={true}
                />
              </div>
            </Col>

            <Col md={12} lg={12}>
              <div className="mb-3">
                <Label htmlFor="title" className="form-label">
                  {t("Total Amount")}{" "}
                </Label>
                <Input
                  name="title"
                  type="text"
                  className="form-control"
                  id="title"
                  placeholder={t("Total Amount")}
                  value={formatNumberWithCommas(formik?.values?.totalAmount)}
                  disabled={true}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PurchaseInformation;
